/* eslint-disable import/no-dynamic-require */
import Config from '@/config'

const { project } = Config
const colors = require(`./themes/${project.theme}/colors`)
export default colors.default
